document.addEventListener('DOMContentLoaded', () => {
    const gallery = document.querySelector('.imageCustom-center');
    const infoMobile = document.querySelector('.infoMobile');
    let userInteracted = false;
    let isGalleryBottom = false;

    if (!gallery || !infoMobile) {
        console.warn('Gallery or infoMobile element not found.');
        return;
    }

    const images = document.querySelectorAll('.product-image');

    // Function to check if all images are loaded
    const areImagesLoaded = () => Array.from(images).every(img => img.complete && img.naturalHeight !== 0);

    // Function to check gallery scroll position
    const checkGalleryScroll = () => {
        isGalleryBottom = gallery.scrollTop + gallery.clientHeight >= gallery.scrollHeight - 5;
    };

    let touchStartY = 0;
    const touchThreshold = 10; // Minimum movement to trigger behavior

    // Gallery touch events
    gallery.addEventListener('touchstart', event => {
        touchStartY = event.touches[0].clientY;
    });

    gallery.addEventListener('touchmove', event => {
        const touchEndY = event.touches[0].clientY;
        const scrollDirection = touchEndY > touchStartY ? 'up' : 'down';
        if (Math.abs(touchEndY - touchStartY) > touchThreshold) {
            checkGalleryScroll();
            if (scrollDirection === 'down' && isGalleryBottom) {
                infoMobile.classList.add('is-expanded');
            }
        }
        touchStartY = touchEndY;
    }, { passive: true });

    // InfoMobile touch events
    infoMobile.addEventListener('touchstart', event => {
        touchStartY = event.touches[0].clientY;
    });

    infoMobile.addEventListener('touchmove', event => {
        const touchEndY = event.touches[0].clientY;
        const scrollDirection = touchEndY > touchStartY ? 'up' : 'down';
        if (Math.abs(touchEndY - touchStartY) > touchThreshold) {
            if (scrollDirection === 'up' && infoMobile.classList.contains('is-expanded')) {
                infoMobile.classList.remove('is-expanded');
            }
        }
        touchStartY = touchEndY;
    }, { passive: true });

    // Function to initialize when user interacts & images are loaded
    const initializeWhenReady = () => {
        if (userInteracted && areImagesLoaded()) {
            checkGalleryScroll();
        }
    };

    // Detect user interaction
    ['mousemove', 'keydown', 'touchstart', 'click'].forEach(eventType => {
        window.addEventListener(eventType, () => {
            userInteracted = true;
            initializeWhenReady();
        }, { once: true });
    });

    // Listen for image load instead of setInterval
    images.forEach(img => {
        if (!img.complete) {
            img.addEventListener('load', initializeWhenReady);
            img.addEventListener('error', initializeWhenReady);
        }
    });
});
